import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/SectionLabel";
import RegisterStrip from "@/components/RegisterStrip";
import { SCHEDULE_DAYS } from "@/data/eventData";

const DayTimeline = ({ day, index }) => (
    <section
        id={day.id}
        data-testid={`schedule-${day.id}`}
        className="scroll-mt-28 py-14 md:py-20"
    >
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
            <Reveal>
                <div className="flex flex-wrap items-baseline gap-x-6 gap-y-2">
                    <h2 className="font-serif text-4xl font-light tracking-tight text-cream md:text-6xl">
                        {day.day}
                    </h2>
                    <p className="font-serif text-xl font-light italic text-scarlet md:text-2xl">
                        {day.tagline}
                    </p>
                    <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.3em] text-ash md:text-[11px]">
                        {day.date}
                    </p>
                </div>
            </Reveal>

            <div className="relative ml-2 mt-12 border-l border-crimson/40 pl-8 md:ml-4 md:pl-14">
                {day.items.map((item, i) => (
                    <Reveal key={item.title} delay={i * 0.05} y={24}>
                        <div className="relative pb-8 last:pb-0">
                            <span
                                aria-hidden="true"
                                className="absolute -left-[37px] top-7 h-2.5 w-2.5 rounded-full bg-scarlet shadow-[0_0_14px_rgba(227,38,46,0.7)] md:-left-[61px]"
                            />
                            <div
                                data-testid={`schedule-item-${day.id}-${i}`}
                                className="group border border-cream/5 bg-coal p-6 transition-colors duration-500 hover:border-crimson/50 md:p-8"
                            >
                                <div className="flex flex-wrap items-baseline justify-between gap-x-8 gap-y-2">
                                    <h3 className="font-serif text-2xl font-light tracking-tight text-cream transition-colors duration-300 group-hover:text-scarlet md:text-3xl">
                                        {item.title}
                                    </h3>
                                    <span className="font-sans text-[11px] font-semibold uppercase tracking-[0.3em] text-scarlet">
                                        {item.time}
                                    </span>
                                </div>
                                {item.note && (
                                    <p className="mt-3 max-w-lg text-sm font-light leading-relaxed text-ash">
                                        {item.note}
                                    </p>
                                )}
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
        {index === 0 && (
            <div aria-hidden="true" className="mx-auto mt-14 max-w-[1400px] px-5 md:mt-20 md:px-10">
                <div className="h-px bg-gradient-to-r from-transparent via-crimson/40 to-transparent" />
            </div>
        )}
    </section>
);

export default function Schedule() {
    return (
        <>
            <section className="relative overflow-hidden pb-6 pt-32 md:pb-10 md:pt-44">
                <div
                    aria-hidden="true"
                    className="absolute inset-0 bg-[radial-gradient(ellipse_80%_55%_at_50%_-10%,rgba(201,31,38,0.16),transparent_62%)]"
                />
                <div className="relative mx-auto max-w-[1400px] px-5 md:px-10">
                    <Reveal y={20}>
                        <SectionLabel index="03" text="Two Days · BHU" />
                    </Reveal>
                    <Reveal delay={0.1} y={20}>
                        <h1
                            data-testid="schedule-heading"
                            className="mt-8 max-w-4xl font-serif text-5xl font-light leading-[1.02] tracking-tight text-cream sm:text-6xl lg:text-7xl"
                        >
                            Two Days.
                            <br />
                            Infinite <em className="italic text-scarlet">Ideas.</em>
                        </h1>
                    </Reveal>
                    <Reveal delay={0.2} y={20}>
                        <p className="mt-8 max-w-xl text-base font-light leading-relaxed text-ash md:text-lg">
                            The official flow of the conference. Detailed timings are
                            released by the Secretariat closer to the event.
                        </p>
                    </Reveal>
                </div>
            </section>

            {SCHEDULE_DAYS.map((day, i) => (
                <DayTimeline key={day.id} day={day} index={i} />
            ))}

            <RegisterStrip text="Mark the days. The gavel waits for no one." />
        </>
    );
}
